import { Play } from '@hiberworld/icons';
import { ProjectLink } from 'components/legacy/Links/ProjectLink';
import { UserLink } from 'components/legacy/Links/UserLink';
import { VerifiedBadge } from 'components/globals/VerifiedBadge';
import { useDive } from 'hooks/useDive';

import { useState } from 'react';
import * as S from './OnlineFriends.styles';
import { PlayingFriendProps } from './OnlineFriends.types';
import { Button } from 'components/common/buttons/Button';

export const PlayingFriend = ({
  user: { username, pictureUrl, isVerified, isEmployee, activeSession },
  onSessionClick,
  onProjectClick,
  onUserClick,
}: PlayingFriendProps) => {
  const [joining, setJoining] = useState(false);
  const dive = useDive();
  const currentProject = activeSession?.project;
  const projectId = currentProject?.id;
  const thumbnail = currentProject?.thumbnail;
  const title = currentProject?.title;

  const handleJoin = () => {
    onSessionClick?.();
    setJoining(true);
    if (activeSession?.sessionUrl) {
      dive.trackGameInit(projectId ?? '');
      window.location.href = activeSession.sessionUrl;
    }
    setJoining(false);
  };

  return (
    <S.PlayingCard thumbnail={thumbnail} data-testid="online-friend">
      <S.InfoRow>
        <UserLink username={username}>
          <S.ProfilePicture src={pictureUrl} onClick={onUserClick} alt={`Visit ${username}'s profile`} />
        </UserLink>
        <div className="flex justify-between flex-col">
          <UserLink username={username}>
            <S.Username data-testid="online-friend-username" onClick={onUserClick}>
              {username}
              <VerifiedBadge isEmployee={isEmployee} isVerified={isVerified} size={20} />
            </S.Username>
          </UserLink>
          <S.SubTitle>is playing</S.SubTitle>
        </div>
      </S.InfoRow>

      <ProjectLink id={projectId ?? ''}>
        <S.Title onClick={onProjectClick}>{title}</S.Title>
      </ProjectLink>
      <Button
        className="w-[74px] py-2 rounded-xl h-[24px] min-h-[unset] pointer-events-auto text-greyscale-white"
        variety="primary"
        size="small"
        text="Join"
        Icon={<Play title="Join" />}
        onClick={handleJoin}
        busy={joining}
      />
    </S.PlayingCard>
  );
};
